<template>
    <div class="main">
        <c-panel :title="titulo" :titleIcon="icone">
            <acesso></acesso>
        </c-panel>
    </div>
</template>
<script>
import acesso from "./acesso"
export default {
    components: { acesso },
    data () { return { titulo: '', icone: '' } },
    created () {
        this.titulo = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
        this.icone = 'fas fa-chart-line'
    }
}
</script>
